import PropTypes from 'prop-types';
import * as React from 'react';

const svgBackArrow = (props) => {
  const {className} = props;

  return (
    <svg className={`${className}`} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path d="M23.3333 14H4.66663" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.6666 21L4.66663 14L11.6666 7"
        stroke="#757575"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

svgBackArrow.propTypes = {
  className: PropTypes.string
};

export default svgBackArrow;
